export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11194_CONNECTION_SCORE': 'Connection Score',
    '_11195___ALIGNMENT': '% Alignment'
};
